import {SET_PREVIOUS_ROUTE} from '@actions/actionTypes';

const initialState = {
    previousRoute: null,
};

const routeReducer = (state = initialState, action) => {
    if (SET_PREVIOUS_ROUTE === action.type) {
        return {
            ...state,
            previousRoute: action.payload,
        };
    } else {
        return state;
    }
};

export default routeReducer;
